import { render } from "./ModalTissGuideConfirmation.vue?vue&type=template&id=64f48d6b"
import script from "./ModalTissGuideConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalTissGuideConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__